module.exports = __webpack_public_path__ + "static/media/timer-ended.5e186aec.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/timer-ended.wav
// module id = 835
// module chunks = 0